(function () {
  'use strict';

  function guardMissingActiveMedia() {
    var Gallery = customElements.get('media-gallery');
    if (!Gallery || Gallery.prototype.dbxMissingMediaGuard) return;

    var activate = Gallery.prototype.customSetActiveMedia;
    Gallery.prototype.customSetActiveMedia = function (media) {
      var safeMedia = media || visibleItems(this)[0];
      if (!safeMedia) return;

      var args = Array.prototype.slice.call(arguments);
      args[0] = safeMedia;
      return activate.apply(this, args);
    };
    Gallery.prototype.dbxMissingMediaGuard = true;
  }

  function visibleItems(gallery) {
    return Array.prototype.filter.call(
      gallery.querySelectorAll('.media-viewer__item'),
      function (item) { return item.clientWidth > 0; }
    );
  }

  function currentIndex(gallery, items) {
    var counter = gallery.querySelector('.media-ctrl__current-item');
    var index = counter ? Number(counter.textContent) - 1 : -1;

    if (index >= 0 && index < items.length) return index;

    var viewer = gallery.querySelector('.media-viewer');
    if (!viewer || items.length < 2) return 0;

    var offset = items[1].offsetLeft - items[0].offsetLeft;
    return offset ? Math.round(viewer.scrollLeft / offset) : 0;
  }

  function keepEdgeButtonsAvailable(gallery) {
    var items = visibleItems(gallery);
    if (items.length <= 1) return;

    gallery.querySelectorAll('.media-ctrl__btn[name="prev"], .media-ctrl__btn[name="next"]').forEach(function (button) {
      if (button.disabled) button.disabled = false;
    });
  }

  function initializeGallery(gallery) {
    if (gallery.getAttribute('data-dbx-loop-ready') === 'true') return;

    var controls = gallery.querySelector('.media-ctrl');
    var previousButton = gallery.querySelector('.media-ctrl__btn[name="prev"]');
    var nextButton = gallery.querySelector('.media-ctrl__btn[name="next"]');
    if (!controls || !previousButton || !nextButton) return;

    gallery.setAttribute('data-dbx-loop-ready', 'true');

    controls.addEventListener('click', function (event) {
      var button = event.target.closest('.media-ctrl__btn');
      if (!button) return;

      var items = visibleItems(gallery);
      if (items.length <= 1) return;

      var index = currentIndex(gallery, items);
      var target = null;

      if (button === nextButton && index === items.length - 1) {
        target = items[0];
      } else if (button === previousButton && index === 0) {
        target = items[items.length - 1];
      }

      if (!target) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      if (typeof gallery.customSetActiveMedia === 'function') {
        gallery.customSetActiveMedia(target, true);
      } else {
        var viewer = gallery.querySelector('.media-viewer');
        if (viewer) viewer.scrollTo({ left: target.offsetLeft });
      }
    }, true);

    new MutationObserver(function () {
      keepEdgeButtonsAvailable(gallery);
    }).observe(controls, {
      attributes: true,
      attributeFilter: ['disabled'],
      subtree: true
    });

    keepEdgeButtonsAvailable(gallery);
  }

  function scan() {
    guardMissingActiveMedia();
    document.querySelectorAll('media-gallery').forEach(initializeGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  new MutationObserver(scan).observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  customElements.whenDefined('media-gallery').then(scan);
}());
